<template>
  <h6 class="font-medium text-gray-700 my-0 text-sm mb-4">
    <slot />
  </h6>
</template>
